import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { employee } from "../../pages/main-pages/super-admin/employees/list/EmployeeList";

export interface Pagination {
  total: number;
  pageNumber: number;
  pageSize: number;
  totalPages: number;
}

export interface Employee {
  userId: string;
  employeeId: string;
  email: string;
  firstName: string;
  lastName: string;
  status: string;
  department: string;
  webId: string;
  vpCode: string;
  isActive: boolean;
}

export interface employeeState {
  pagination: Pagination;
  employees: Employee[];
}

const initialState: employeeState = {
  pagination: { total: 0, pageNumber: 1, pageSize: 10, totalPages: 1 },
  employees: [],
};
const EmployeeSliceReducer = createSlice({
  name: "Employee",
  initialState,
  reducers: {
    dispatchEmployeeListData(state, action: PayloadAction<employeeState>) {
      state.employees = action?.payload.employees;
      state.pagination = action?.payload?.pagination;
    },
  },
});

export const { dispatchEmployeeListData } = EmployeeSliceReducer.actions;

export default EmployeeSliceReducer.reducer;
